import React, { Component, useState } from "react";
import styled, { css } from "react-emotion";
import PropTypes from "prop-types";
import CloseIcon from "@material-ui/icons/Close";

const StyledBurger = styled("button")`
  left: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;

  &:focus {
    outline: none;
  }

  div {
    width: 2rem;
    height: 0.25rem;
    background: ${(props) => (props.open ? "white" : "#89d2d3")};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;
    z-index: 3;
  }
`;

const Burger = ({ open, setOpen }) => {
  if (open) {
    return (
      <CloseIcon onClick={() => setOpen(false)} style={{ zIndex: "13" }} />
    );
  }
  return (
    <StyledBurger open={open} onClick={() => setOpen(!open)}>
      <div />
      <div />
      <div />
    </StyledBurger>
  );
};

Burger.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default Burger;
